<template>
  <div class="hotel-select">
    <div
      class="hotel-select__label"
      :class="{ 'active-title': isActive, 'error-title': isError }"
    >
      <p>{{ $t("booking.where_in_japan") }}</p>
    </div>
    <multiselect
      v-model="value"
      track-by="hotelId"
      label="name"
      selectLabel=""
      deselectGroupLabel=""
      deselectLabel=""
      selectedLabel=""
      :class="{
        'multiselect--error': isError,
      }"
      :placeholder="$t('booking.search_hotels_destinations')"
      :options="hotels"
      :open="true"
      @input="setSelected"
      @open="onOpen"
    ></multiselect>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
export default {
  name: "HotelSelect",
  components: { Multiselect },
  props: {
    hotels: {
      type: Array,
      required: true,
    },
    selectedHotel: {
      type: Object,
      default: null,
    },
    isActive: {
      type: Boolean,
      default: true,
    },
    isError: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      value: null,
    };
  },
  methods: {
    setSelected(hotel) {
      this.$emit("update:selectedHotel", hotel);
    },

    onOpen() {
      this.$emit("onOpen");
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.multiselect {
  &__tags {
    height: 50px;
    border: 2px solid #dddee0;
    border-radius: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @include min-sm {
      height: 60px;
    }
  }

  &__select {
    height: 48px;

    @include min-sm {
      height: 60px;
    }
  }

  &__single {
    white-space: nowrap;
    font-size: 14px;
    text-overflow: ellipsis;
    overflow: hidden;  
  }

  &__option {
    white-space: pre-line;
    line-height: 22px;
    &--highlight,
    &--selected.multiselect__option--highlight {
      background: #60a5fa;
      color: #fff;
    }

    &--selected {
      font-weight: 500;
    }
  }

  &__content {
    font-size: 14px;
    overflow: hidden;

  }

  &__placeholder {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__element {
    white-space: pre-line;
  }

  &__content-wrapper {
    overflow: hidden;
  }

  &--error {
    .multiselect__tags {
      border-color: red;
    }

    .multiselect__placeholder {
      color: red;
    }
  }
}

.hotel-select {
  p {
    font-size: 13px;
    color: #232e48;
    margin-bottom: 12px;
  }

  .active-title p {
    color: #fff;
  }

  .error-title p {
    color: red;
  }
  &__label {
    text-align: center;
    display: none;

    @include min-sm {
      display: block;
    }
  }
}
</style>
